import PreviousSurvey from './PreviousSurvey';

export default PreviousSurvey;